// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__32Gc0","rootSuccess":"CompleteLink_rootSuccess__YtQsa","rootFailure":"CompleteLink_rootFailure__YJDB8","isDisabled":"CompleteLink_isDisabled__3NDqU"};